import { useTranslation } from 'react-i18next'

const DynamicStrings = ({ id, suffix }) => {
    const { t } = useTranslation()

    return t(id) + (suffix ? ' ' + t(suffix) : '')
}

export default DynamicStrings
